<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div class="container-fluid">
            <CRow>
                <CCol>
                    <!-- Page Header -->
                    <div class='pageHeader position-relative'>
                        <!-- Page Title -->
                        <h2 id="titleHeight">{{this.getLanguage['SMB']['GAS']}}</h2>

                        <div class="custom_tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="tooltiptext tooltip-left" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="tooltiptext tooltip-left" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <!-- Search Bar -->
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <!-- Game Category -->
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GAME']['CAT']}}</span>
                                <treeselect :multiple="false"
                                            :load-options="loadCategoryOptions"
                                            :options="ddCategoryList"
                                            :auto-load-root-options="false"
                                            @input="InputCategory"
                                            v-model="searchCategory"
                                            placeholder />
                            </div>
                            <!-- Game Provider -->
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GAME']['PROV']}}</span>
                                <treeselect :multiple="false"
                                            :load-options="loadProviderOptions"
                                            :options="ddProviderList"
                                            :auto-load-root-options="false"
                                            :noOptionsText="this.getLanguage['GL']['NOA']"
                                            v-model="searchProvider"
                                            placeholder />
                            </div>
                            <!-- Game Name -->
                            <div class="searchCol">
                                <span class="searchLabel">{{this.getLanguage['PM']['GG']}} {{this.getLanguage['GAME']['NM']}} :</span>
                                <treeselect :key="dd_memberKey"
                                            :multiple="false"
                                            :async="true"
                                            :options="ddGameNameList"
                                            :auto-load-root-options="convertToBool(searchGameNameId > 0 && searchGameName)"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.getLanguage['AC']['SearchGame']"
                                            @input="handleGameNameOptions"
                                            :load-options="handleGameNameSearchChange"
                                            :cacheOptions="false"
                                            v-model="searchGameNameId" />
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" @shortkey="newSearch()" class='searchBtn' ref="search" size="sm" block color="success" @click="newSearch()"><span class='searchIcon cil-search'></span><span>{{this.getLanguage["BTN"]["SR"]}}</span></CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>

            <!-- Game List Table -->
            <div class='table-wrapper'>
                <header class="table-header">
                    <!-- Table Title -->
                    <strong>
                        {{this.getLanguage['SMB']['GAS']}}
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </strong>
                    <div>
                        <!-- Save Button -->
                        <CButton v-if="checkModuleAccess2(constAccessType.edit)" class='searchBtn' size="sm" color="info" @click="SaveConfig()"><span>{{this.getLanguage["BTN"]["SV"]}}</span></CButton>
                        <!-- Page Button -->
                        <div class="pageBtn">
                            <!-- Previous Page Button -->
                            <button @click="ctrPage(+int_Page - 1)">
                                <span class="arrowLeft"></span>
                            </button>
                            <!-- Page Number Input -->
                            <input class="page-control"
                                   v-model="int_Page"
                                   type="number"
                                   v-shortkey.avoid
                                   @keyup="ctrPage(+int_Page,0)" />
                            <span class="tableItemCount">/ {{int_TP}}</span>
                            <!-- Next Page Button -->
                            <button @click="ctrPage(+int_Page + 1)">
                                <span class="arrowRight"></span>
                            </button>
                        </div>
                    </div>
                </header>

                <!-- Table Header -->
                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <!-- No -->
                                <th>{{this.getLanguage['GL']['NO']}}.</th>
                                <!-- Game Provider -->
                                <th>{{this.getLanguage['GAME']['PROV']}} <i @click="setSortTable('PN')" :class="['sortlogo', setSortLogo('PN')]"></i></th>
                                <!-- Game Category -->
                                <th>{{this.getLanguage['GAME']['CAT']}} <i @click="setSortTable('CN')" :class="['sortlogo', setSortLogo('CN')]"></i></th>
                                <!-- Game Name -->
                                <th>{{this.getLanguage['PM']['GG']}} {{this.getLanguage['GAME']['NM']}}</th>
                                <th>
                                    <div class="d-flex align-items-center" style="gap:5px;white-space:nowrap">
                                        {{this.getLanguage['GATTR']['BFS']}}
                                        <span class="float-right">
                                            <label class="switch">
                                                <input type="checkbox" v-model="selectBuyFreeSpin">
                                                <span class="slider round"></span>
                                            </label>
                                        </span>
                                    </div>
                                </th>
                                <th>
                                    <div class="d-flex align-items-center" style="gap:5px;white-space:nowrap">
                                        {{this.getLanguage['GATTR']['GF']}}
                                        <span class="float-right">
                                            <label class="switch">
                                                <input type="checkbox" v-model="selectFeatureGame">
                                                <span class="slider round"></span>
                                            </label>
                                        </span>
                                    </div>
                                </th>
                                <th>
                                    <div class="d-flex align-items-center" style="gap:5px;white-space:nowrap">
                                        {{this.getLanguage['GATTR']['JP']}}
                                        <span class="float-right">
                                            <label class="switch">
                                                <input type="checkbox" v-model="selectJackpot">
                                                <span class="slider round"></span>
                                            </label>
                                        </span>
                                    </div>
                                </th>
                                <th>
                                    <div class="d-flex align-items-center" style="gap:5px;white-space:nowrap">
                                        {{this.getLanguage['GATTR']['EXC']}}
                                        <span class="float-right">
                                            <label class="switch">
                                                <input type="checkbox" v-model="selectExclusive">
                                                <span class="slider round"></span>
                                            </label>
                                        </span>
                                    </div>
                                </th>
                                <th>
                                    <div class="d-flex align-items-center" style="gap:5px;white-space:nowrap">                                        
                                        {{this.getLanguage['GATTR']['MEGAW']}}
                                        <span class="float-right">
                                            <label class="switch">
                                                <input type="checkbox" v-model="selectMegaways">
                                                <span class="slider round"></span>
                                            </label>
                                        </span>
                                    </div>
                                </th>
                                <th>
                                    {{this.getLanguage['GATTR']['RTPS']}}
                                </th>
                            </tr>
                        </thead>
                    </table>
                </div>

                <!-- Table Body -->
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <!-- No -->
                                <th>{{this.getLanguage['GL']['NO']}}.</th>
                                <!-- Game Provider -->
                                <th>{{this.getLanguage['GAME']['PROV']}} <i @click="setSortTable('PN')" :class="['sortlogo', setSortLogo('PN')]"></i></th>
                                <!-- Game Category -->
                                <th>{{this.getLanguage['GAME']['CAT']}} <i @click="setSortTable('CN')" :class="['sortlogo', setSortLogo('CN')]"></i></th>
                                <!-- Game Name -->
                                <th>{{this.getLanguage['PM']['GG']}} {{this.getLanguage['GAME']['NM']}}</th>
                                <th>
                                    <div class="d-flex align-items-center" style="gap:5px;white-space:nowrap">
                                        {{this.getLanguage['GATTR']['BFS']}}
                                        <span class="float-right">
                                            <label class="switch">
                                                <input type="checkbox" v-model="selectBuyFreeSpin">
                                                <span class="slider round"></span>
                                            </label>
                                        </span>
                                    </div>
                                </th>
                                <th>
                                    <div class="d-flex align-items-center" style="gap:5px;white-space:nowrap">
                                        {{this.getLanguage['GATTR']['GF']}}
                                        <span class="float-right">
                                            <label class="switch">
                                                <input type="checkbox" v-model="selectFeatureGame">
                                                <span class="slider round"></span>
                                            </label>
                                        </span>
                                    </div>
                                </th>
                                <th>
                                    <div class="d-flex align-items-center" style="gap:5px;white-space:nowrap">
                                        {{this.getLanguage['GATTR']['JP']}}
                                        <span class="float-right">
                                            <label class="switch">
                                                <input type="checkbox" v-model="selectJackpot">
                                                <span class="slider round"></span>
                                            </label>
                                        </span>
                                    </div>
                                </th>
                                <th>
                                    <div class="d-flex align-items-center" style="gap:5px;white-space:nowrap">
                                        {{this.getLanguage['GATTR']['EXC']}}
                                        <span class="float-right">
                                            <label class="switch">
                                                <input type="checkbox" v-model="selectExclusive">
                                                <span class="slider round"></span>
                                            </label>
                                        </span>
                                    </div>
                                </th>
                                <th>
                                    <div class="d-flex align-items-center" style="gap:5px;white-space:nowrap">
                                        Megaways
                                        <span class="float-right">
                                            <label class="switch">
                                                <input type="checkbox" v-model="selectMegaways">
                                                <span class="slider round"></span>
                                            </label>
                                        </span>
                                    </div>
                                </th>
                                <th>
                                    RTP (Slots)
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <td colspan="100%" v-if=" arr_GameList.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                            <tr v-for="(data,index) in arr_GameList">
                                <td>{{ CountItem(index+1) }}</td>
                                <td>{{ renderProviderName(data.ProviderName) }}</td>
                                <td>{{ renderCategory(data.GameCategoryId) }}</td>
                                <td>{{ renderGameName( data.ProviderName, data.GameName ) }}</td>
                                <td v-if="checkModuleAccess2(constAccessType.view)" class="text-center">
                                    <CCol>
                                        <label class="switch">
                                            <input type="checkbox" :checked="data.HasBuyFreeSpin" v-model="data.HasBuyFreeSpin" @change="v=>configChanged('HasBuyFreeSpin',index)"
                                                   true-value="true" false-value="false">
                                            <span class="slider round"></span>
                                        </label>
                                    </CCol>
                                </td>
                                <td v-if="checkModuleAccess2(constAccessType.view)" class="text-center">
                                    <CCol>
                                        <label class="switch">
                                            <input type="checkbox" :checked="data.HasFeatureGames" v-model="data.HasFeatureGames" @change="v=>configChanged('HasFeatureGames',index)"
                                                   true-value="true" false-value="false" name="HasFeatureGames">
                                            <span class="slider round"></span>
                                        </label>
                                    </CCol>
                                </td>
                                <td v-if="checkModuleAccess2(constAccessType.view)" class="text-center">
                                    <CCol>
                                        <label class="switch">
                                            <input type="checkbox" :checked="data.HasJackpot" v-model="data.HasJackpot" @change="v=>configChanged('HasJackpot',index)"
                                                   true-value="true" false-value="false" name="HasJackpot">
                                            <span class="slider round"></span>
                                        </label>
                                    </CCol>
                                </td>
                                <td v-if="checkModuleAccess2(constAccessType.view)" class="text-center">
                                    <CCol>
                                        <label class="switch">
                                            <input type="checkbox" :checked="data.EXclusive" v-model="data.EXclusive" @change="v=>configChanged('EXclusive',index)"
                                                   true-value="1" false-value="2" name="EXclusive">
                                            <span class="slider round"></span>
                                        </label>
                                    </CCol>
                                </td>
                                <td v-if="checkModuleAccess2(constAccessType.view)" class="text-center">
                                    <CCol>
                                        <label class="switch">
                                            <input type="checkbox" :checked="data.MEgaways" v-model="data.MEgaways" @change="v=>configChanged('MEgaways',index)"
                                                   true-value="1" false-value="2" name="MEgaways">
                                            <span class="slider round"></span>
                                        </label>
                                    </CCol>
                                </td>
                                <td v-if="checkModuleAccess2(constAccessType.view)" class="text-center">
                                    <CInput v-if="hasRTP(data.GameCategoryId)"
                                            append="%"
                                            size="sm"
                                            vertical
                                            type="number" min="0.0" step="0.1" max="100.00"
                                            placeholder="RTP"
                                            v-model="data.RTP" @change="v=>configChanged('RTP',index)"
                                            ref="ER" />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- Table Footer -->
                <footer class="d-flex justify-content-end py-2">
                    <!-- Save Button -->
                    <CButton v-if="checkModuleAccess2(constAccessType.edit)" class='searchBtn' size="sm" color="info" @click="SaveConfig()"><span>{{this.getLanguage["BTN"]["SV"]}}</span></CButton>
                    <!-- Page Button -->
                    <div class="pageBtn">
                        <!-- Previous Page Button -->
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <!-- Page Number Input -->
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <!-- Next Page Button -->
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { mapGetters } from 'vuex';
    import $ from 'jquery';
    import genericHelper from "@/modules/GenericHelper.js";
    import { constAccessType, constStatus, loadingFullScreen } from '@/modules/Constant.js';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import Loading from 'vue-loading-overlay';

    import Treeselect from '@riophae/vue-treeselect';
    import '@riophae/vue-treeselect/dist/vue-treeselect.css';

    export default {
        mixins: [genericHelper],
        components: {
            Treeselect,
            Loading
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['checkModuleAccess']),
            selectBuyFreeSpin: {
                get: function () {
                    // If GameList not exists, return false
                    if (!this.arr_GameList || this.arr_GameList.length === 0) return false;
                    // If All GameList's item.HasBuyFreeSpin === true, Turn the switch on (TRUE)
                    return this.arr_GameList.every((item) => item.HasBuyFreeSpin === true);
                },
                set: function (value) {
                    // If GameList not exists, return false
                    if (!this.arr_GameList || this.arr_GameList.length === 0) return false;
                    // For each items in GameList
                    this.arr_GameList.forEach((item) => {
                        // Only track changes if there is a change in HasBuyFreeSpin
                        if (item.HasBuyFreeSpin !== (value ? true : false)) {
                            const changedConfig = this.changedConfigs.find(
                                (config) => config.I === item.I // if the config.I match item.I, object config is returned.
                            );
                            if (!changedConfig) {
                                this.changedConfigs.push(item);
                            }
                            // Update HasBuyFreeSpin based on the checkbox state
                            item.HasBuyFreeSpin = value ? true : false;
                        }
                    });
                }
            },
            selectFeatureGame: {
                get: function () {
                    // If GameList not exists, return false
                    if (!this.arr_GameList || this.arr_GameList.length === 0) return false;
                    // If All GameList's item.HasFeatureGames === true, Turn the switch on (TRUE)
                    return this.arr_GameList.every((item) => item.HasFeatureGames === true);
                },
                set: function (value) {
                    // If GameList not exists, return false
                    if (!this.arr_GameList || this.arr_GameList.length === 0) return false;
                    // For each items in GameList
                    this.arr_GameList.forEach((item) => {
                        // Only track changes if there is a change in HasFeatureGames
                        if (item.HasFeatureGames !== (value ? true : false)) {
                            const changedConfig = this.changedConfigs.find(
                                (config) => config.I === item.I // if the config.I match item.I, object config is returned.
                            );
                            if (!changedConfig) {
                                this.changedConfigs.push(item);
                            }
                            // Update each item's HasFeatureGames based on the checkbox state
                            item.HasFeatureGames = value ? true : false;
                        }
                    });
                }
            },
            selectJackpot: {
                get: function () {
                    // If GameList not exists, return false
                    if (!this.arr_GameList || this.arr_GameList.length === 0) return false;
                    // If All GameList's item.HasJackpot === true, Turn the switch on (TRUE)
                    return this.arr_GameList.every((item) => item.HasJackpot === true);

                },
                set: function (value) {
                    // If GameList not exists, return false
                    if (!this.arr_GameList || this.arr_GameList.length === 0) return false;
                    // For each items in GameList
                    this.arr_GameList.forEach((item) => {
                        // Only track changes if there is a change in HasJackpot
                        if (item.HasJackpot !== (value ? true : false)) {
                            const changedConfig = this.changedConfigs.find(
                                (config) => config.I === item.I // if the config.I match item.I, object config is returned.
                            );
                            if (!changedConfig) {
                                this.changedConfigs.push(item);
                            }
                            // Update each item's HasJackpot based on the checkbox state
                            item.HasJackpot = value ? true : false;
                        }
                    });
                }
            },
            selectExclusive: {
                get: function () {
                    // If GameList not exists, return false
                    if (!this.arr_GameList || this.arr_GameList.length === 0) return false;
                    // If All GameList's item.EXclusive === true, Turn the switch on (TRUE)
                    return this.arr_GameList.every((item) => item.EXclusive === true);

                },
                set: function (value) {
                    // If GameList not exists, return false
                    if (!this.arr_GameList || this.arr_GameList.length === 0) return false;
                    // For each items in GameList
                    this.arr_GameList.forEach((item) => {
                        // Only track changes if there is a change in EXclusive
                        if (item.EXclusive !== (value ? true : false)) {
                            const changedConfig = this.changedConfigs.find(
                                (config) => config.I === item.I // if the config.I match item.I, object config is returned.
                            );
                            if (!changedConfig) {
                                this.changedConfigs.push(item);
                            }
                            // Update each item's EXclusive based on the checkbox state
                            item.EXclusive = value ? 1 : 2;
                        }
                    });
                }
            },
            selectMegaways: {
                get: function () {
                    // If GameList not exists, return false
                    if (!this.arr_GameList || this.arr_GameList.length === 0) return false;
                    // If All GameList's item.MEgaways === true, Turn the switch on (TRUE)
                    return this.arr_GameList.every((item) => item.MEgaways === true);

                },
                set: function (value) {
                    // If GameList not exists, return false
                    if (!this.arr_GameList || this.arr_GameList.length === 0) return false;
                    // For each items in GameList
                    this.arr_GameList.forEach((item) => {
                        // Only track changes if there is a change in MEgaways
                        if (item.MEgaways !== (value ? true : false)) {
                            const changedConfig = this.changedConfigs.find(
                                (config) => config.I === item.I // if the config.I match item.I, object config is returned.
                            );
                            if (!changedConfig) {
                                this.changedConfigs.push(item);
                            }
                            // Update each item's MEgaways based on the checkbox state
                            item.MEgaways = value ? 1 : 2;
                        }
                    });
                }
            }
        },
        data() {
            return {
                constAccessType: constAccessType,
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_showSearchBar: true,
                bool_isSort: false, // Sort Table

                int_RC: 100, // Row Count
                int_Total: 0,
                int_Page: 1,
                int_IC: 1, // Item Count
                int_TP: 1, // Total Page

                searchCategory: null,
                searchProvider: null,
                str_FV: "", //Filter Value

                ddCategoryList: null,
                ddProviderList: null,

                str_tableSortBy: "", // Sort table by "Columne Name"

                // Data for Filter/Search GameName Dropdown List
                dd_memberKey: 0,
                memberName: "",
                ddGameNameList: null,
                obj_Post: {
                    SelectedProvider: null,
                    SelectedCategory: null,
                },
                searchGameNameId: null,
                searchGameName: null,

                changedConfigs: [], // Track modified configurations
                selected_items: [],
                checkAll: false,
                arr_GameList: [],

                // Each Game data get from GetGameList
                data: {
                    RTP: 80, // Set default RTP value to 80
                }
            }
        },
        methods: {
            checkModuleAccess2(type) {
                return this.checkModuleAccess('GAS', 'WEBS', type);
            },
            newSearch() {
                this.$refs.search.focus();
                this.int_Page = 1;
                this.int_IC = 1;
                this.getGameList();
            },
            getCategory() {
                for (var i = 0; i < this.ddCategoryList.length; i++) {
                    this.ddCategoryList[i].label = this.renderCategory(this.ddCategoryList[i].id);
                }
            },
            getGameList() {
                this.bool_fullLoading = true;
                var that = this;
                var hasDefaultPath = false;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);
                if (path) {
                    hasDefaultPath = true;
                }

                if (this.searchCategory) {
                    path += ("&f.CategoryId=" + this.searchCategory);
                }
                if (this.searchProvider) {
                    path += ("&f.ProviderId=" + this.searchProvider);
                }
                if (this.searchGameName) {
                    path += ("&f.GameName=" + this.searchGameName);
                }

                if (!hasDefaultPath && path) {
                    path = path.substring(1);
                }

                this.getDataApi(`/api/gasetting/l?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.int_TP = Math.max(d.D.TotalPages, 1);
                            that.int_Total = d.D.TotalItems;
                            that.arr_GameList = d.D.Items;
                            that.changedConfigs = [];
                            that.checkAll = false;
                            that.resizeTableHead();
                        }
                    });
            },
            loadProviderOptions({ action, callback, instanceId }) {
                var that = this;
                this.getDataApi(`/api/dd/gameProv/`,

                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            const filteredList = d.dropdownlist.filter(item => {
                                if (item.label) {
                                    return !item.label.trim().toLowerCase().includes("sports"); // Exclude provider with sports in its name
                                }
                                return true; // Include items with no provider field
                            });

                            for (var i = 0; i < filteredList.length; i++) {
                                filteredList[i].label = that.renderProviderName(filteredList[i].label2);
                            }

                            that.ddProviderList = filteredList;
                        }
                        else {
                            that.ddProviderList = null;
                        }

                        callback();
                    });
            },
            loadCategoryOptions({ action, callback, instanceId }) {
                var that = this;
                this.getDataApi(`/api/dd/gameCat`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            // Filter out the category with id = 2 (SPORTSBOOK)
                            const filteredList = d.dropdownlist.filter(item => {
                                const matchCategory = item.id !== "2";
                                return matchCategory;
                            });
                            for (var i = 0; i < filteredList.length; i++) {
                                filteredList[i].label = that.renderCategory(filteredList[i].id);
                            }
                            that.ddCategoryList = filteredList;
                        }
                        else {
                            that.ddCategoryList = null;
                        }

                        callback();
                    });
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV; // Sort by 'PN' ProviderName or 'CN'Category
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                this.getGameList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            SaveConfig() {
                this.bool_fullLoading = true;
                this.bool_fullScreen = true;
                var that = this;
                this.postDataApi(`/api/gasetting/s`, this.changedConfigs, function (d, s) {
                    that.bool_fullLoading = false;
                    that.bool_fullScreen = false;
                    if (s) {
                        that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                        that.changedConfigs = [];
                    }
                    that.getGameList();
                });
            },
            InputCategory(value) {
                this.ddProviderList = null;
                this.searchProvider = null;

                if (value != undefined && value > 0) {
                    var that = this;

                    this.getDataApi(`/api/dd/gameProvByCatId/` + value,

                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                for (var i = 0; i < d.dropdownlist.length; i++) {
                                    d.dropdownlist[i].label = that.renderProviderName(d.dropdownlist[i].label2);
                                }

                                that.ddProviderList = d.dropdownlist;
                            }
                            else {
                                that.ddProviderList = null;
                            }
                        });
                }
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getGameList();
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            configChanged(name, index) {
                
                const currentGameAttribute = this.arr_GameList[index];
                const changedGameAttribute = this.changedConfigs.find((value) => value.I === currentGameAttribute.I);

                if (!changedGameAttribute) {
                    this.changedConfigs.push(currentGameAttribute);
                }
            },
            renderCategory(id) {
                return this.getLanguage["GC"][id];
            },
            renderGameName(providerName, gameName) {
                if (providerName in this.getLanguage && gameName in this.getLanguage[providerName])
                    return this.getLanguage[providerName][gameName];
                else
                    return gameName;
            },

            // Handle Table's Alignment
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0); // Reset horizontal scroll position of #tHead #tBody to (0)leftmost side.
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');
                const headerCellSpans = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th span');

                if (!headerCells.length) return; // If no header cells found, function stop.

                // For each tables
                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td'); // Look for <td> in the first row of <tbody>
                    if (!bodyCells.length) return; // If no bodyCells, function stop.

                    // Reset all widths (Clear all width styles for all header cells and body cells)
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) { headerCells[index].style.width = width; }
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            // Handle Game that has RTP
            hasRTP(gameCategoryId) {
                // Only Slots have RTP (ID = 5)
                return String(gameCategoryId) === "5";
            },

            // Game Name Dropdown List
            loadGameNameOptions() {
                var that = this;
                this.obj_Post.SelectedProvider = this.searchProvider;
                this.obj_Post.SelectedCategory = this.searchCategory;
                this.postDataApi(`/api/gasetting/gamenamedropdownlist`, this.obj_Post,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddGameNameList = d.dropdownlist;
                            for (var idx = 0; idx < that.ddGameNameList.length; idx++) {
                                that.ddGameNameList[idx].label = that.changeGameName(that.ddGameNameList[idx].extra, that.ddGameNameList[idx].label2); // Assign GameName to label
                            }
                            that.$forceUpdate();
                        }
                        else {
                            that.ddGameNameList = [];
                        }
                    });
            },
            handleGameNameSearchChange({ action, searchQuery, callback }) {
                if (
                    searchQuery == null ||
                    searchQuery.trim() === '' ||
                    searchQuery.trim().length < 3
                ) {
                    // Update options to show the placeholder
                    callback(this.getLanguage['MEM']['PS3']); // Need atleast 3 letter to search
                } else {
                    // Filter `ddGameNameList` based on the user's search input, searchCategory, and searchProvider
                    const filteredList = this.ddGameNameList.filter((item) => {
                        const matchesQuery = item.label.toLowerCase().includes(searchQuery.toLowerCase());
                        const matchesCategory = !this.searchCategory || item.extraCat === this.searchCategory;
                        const matchesProvider = !this.searchProvider || item.extra1 === this.searchProvider;
                        return matchesQuery && matchesCategory && matchesProvider;
                    });
                    // If there are results, call the callback with the filtered list, otherwise show 'no results'
                    const results = filteredList.length > 0
                        ? filteredList
                        : [
                            {
                                id: 'no-results',
                                label: 'No results found', // No matching results object
                                isDisabled: true,
                            }
                        ];

                    callback(null, results);  // Call callback to update options with filtered results
                }
            },
            handleGameNameOptions(node, instanceId) {
                if (this.ddGameNameList && this.ddGameNameList.length > 0) {
                    var index = -1;
                    for (var i = 0; i < this.ddGameNameList.length; i++) {
                        if (this.ddGameNameList[i].id == node) {
                            this.searchGameName = this.ddGameNameList[i].label2; // Need search using label2(GameNameId), instead of label(GameName)
                            break;
                        }
                    }
                }
                else {
                    this.searchGameName = null;
                }
                // When nothing selected
                if (node == null) { this.searchGameName = null; }
            },
            changeGameName(provider, item) {
                if (provider in this.getLanguage && item in this.getLanguage[provider]) { item = this.getLanguage[provider][item]; }
                return item;
            },
        },
        created() {
            if (this.$route.path == '/AGS/GAS') {
                this.$parent.showSubMenu = 'AGS';
                this.$parent.showActiveMenu = 'AGS.GAS';
            } else if (this.$route.path == '/WEBS/GAS') {
                this.$parent.showSubMenu = 'WEBS';
                this.$parent.showActiveMenu = 'WEBS.GAS';
            }

            this.getGameList();
            this.loadGameNameOptions();
        },
        watch: {
            int_Page(newValue) {
                if (newValue > 0 && newValue <= this.int_TP) {
                    this.getGameList(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort, this.str_FV);
                }
            },
            getLanguage() {
                this.getCategory();
            },
        }
    };
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/AgentSetting/GameAttributeSetting.vue